import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Input from '../../components/ui/Input.jsx';
import Button from '../../components/ui/Button.jsx';
import { apiFetch } from '../../api.js';
import { RouteContext } from '../../router.jsx';

export default function StaffSurveyNew() {
  const { navigate } = React.useContext(RouteContext);
  const [form, setForm] = React.useState({ name: '', semester: 'Fall', year: '' });
  const [saving, setSaving] = React.useState(false);
  const [message, setMessage] = React.useState({ text: '', tone: 'info' });

  const updateField = (key) => (event) => {
    const value = event.target.value;
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setMessage({ text: 'Survey name is required.', tone: 'error' });
      return;
    }

    setSaving(true);
    setMessage({ text: '', tone: 'info' });
    try {
      const data = await apiFetch('/api/surveys', {
        method: 'POST',
        body: JSON.stringify({
          name: form.name.trim(),
          semester: form.semester.trim(),
          year: form.year.trim(),
          status: 0
        })
      });
      navigate(`/staff/surveys/${data.id}`);
    } catch (err) {
      setMessage({ text: err?.message || 'Failed to create survey.', tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>New Survey</h1>
          <p className="subtle">Create a new course demand survey.</p>
        </div>
        <Button variant="secondary" type="button" onClick={() => navigate('/staff/surveys')}>
          Back to Surveys
        </Button>
      </div>

      {message.text ? <div className={message.tone === 'error' ? 'alert error' : 'alert'}>{message.text}</div> : null}

      <Card title="Survey Details">
        <div className="form-grid">
          <Input label="Survey Name" value={form.name} onChange={updateField('name')} placeholder="Spring 2026 Course Demand" />
          <label className="input-field">
            <span className="input-label">Semester</span>
            <select className="input" value={form.semester} onChange={updateField('semester')}>
              <option value="Fall">Fall</option>
              <option value="Spring">Spring</option>
              <option value="Summer">Summer</option>
            </select>
          </label>
          <Input label="Year" value={form.year} onChange={updateField('year')} placeholder="2026" />
        </div>
        <div className="form-actions">
          <Button variant="secondary" type="button" onClick={() => navigate('/staff/surveys')}>Cancel</Button>
          <Button type="button" onClick={handleSubmit} disabled={saving}>
            {saving ? 'Creating…' : 'Create Survey'}
          </Button>
        </div>
      </Card>
    </div>
  );
}
